import React, { useState } from 'react';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '919865076600';
  const message = encodeURIComponent('Hi! I have a question about Beetle Diffuser products.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-cta-btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Chat on WhatsApp"
    >
      {/* Tooltip */}
      <span className={`whatsapp-tooltip ${isHovered ? 'whatsapp-tooltip-visible' : ''}`}>
        Chat with us!
      </span>

      {/* Pulse ring */}
      <span className="whatsapp-pulse" />

      {/* WhatsApp Icon */}
      <svg viewBox="0 0 32 32" width="30" height="30" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.004 0h-.008C7.174 0 .8 6.375.8 14.203c0 3.098 1.006 5.97 2.712 8.305L1.17 29.23l6.998-2.303A14.1 14.1 0 0016.004 28.4C23.83 28.4 30.2 22.028 30.2 14.2 30.2 6.375 23.83 0 16.004 0zm8.413 20.07c-.353.994-1.75 1.82-2.863 2.06-.762.163-1.756.293-5.103-1.096-4.283-1.779-7.032-6.12-7.245-6.406-.205-.286-1.72-2.291-1.72-4.37 0-2.078 1.086-3.098 1.474-3.522.353-.384.929-.576 1.48-.576.178 0 .339.009.483.016.388.018.584.04.84.65.32.762 1.097 2.681 1.193 2.876.098.196.196.454.076.724-.112.278-.213.402-.409.623-.197.222-.384.392-.579.631-.178.209-.38.433-.158.839.22.402.983 1.62 2.112 2.626 1.451 1.293 2.635 1.713 3.072 1.895.32.133.7.1.93-.144.293-.31.655-.823 1.022-1.328.26-.362.592-.408.94-.278.353.124 2.237 1.056 2.622 1.248.384.196.64.286.736.448.094.16.094.933-.26 1.834z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
